import { motion } from "framer-motion";
import { BRAND, MANIFESTO } from "@/components/site/data";

const PORTRAIT = "/mohd-aamir.png";

export default function Manifesto() {
  return (
    <section id="philosophy" className="bg-base py-24 md:py-36" data-testid="manifesto">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-14 lg:gap-10">
          {/* Left: heading + portrait */}
          <div className="lg:col-span-5">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="overline mb-6"
            >
              The Philosophy
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.05 }}
              className="font-serif text-4xl md:text-5xl text-[#1a1a17] leading-tight tracking-tight"
            >
              Wealth is built <span className="italic text-[#0e5b45]">slowly</span>, then all at once.
            </motion.h2>

            <motion.figure
              initial={{ clipPath: "inset(0 0 100% 0)" }}
              whileInView={{ clipPath: "inset(0 0 0% 0)" }}
              viewport={{ once: true }}
              transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
              className="mt-10 relative overflow-hidden rounded-sm group bg-[#0b0b0b]"
              data-testid="advisor-portrait"
            >
              <img
                src={PORTRAIT}
                alt={`${BRAND.name} — AMFI registered mutual fund distributor`}
                className="w-full h-[480px] object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-black/10" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/85 via-black/40 to-transparent">
                <p className="font-serif text-xl text-white tracking-tight">{BRAND.name}</p>
                <p className="text-[0.7rem] uppercase tracking-[0.3em] text-[#c6a87c] mt-1.5">
                  {BRAND.arn} · AMFI Registered Distributor
                </p>
              </figcaption>
            </motion.figure>
          </div>

          {/* Right: numbered chapters */}
          <div className="lg:col-span-6 lg:col-start-7 flex flex-col justify-center">
            <div className="divide-y divide-black/10">
              {MANIFESTO.map((c, i) => (
                <motion.div
                  key={c.no}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                  className="py-9 first:pt-0 flex gap-6 md:gap-10"
                  data-testid={`manifesto-chapter-${c.no}`}
                >
                  <span className="font-serif text-3xl md:text-4xl text-[#0e5b45]/70 shrink-0 leading-none">
                    {c.no}
                  </span>
                  <div>
                    <h3 className="font-serif text-2xl md:text-3xl text-[#1a1a17] mb-3">
                      {c.title}
                    </h3>
                    <p className="text-stone-600 leading-relaxed md:text-lg">{c.body}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
